import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import { getToken } from '@/utils/auth'

Vue.use(Router)

const router =  new Router({
  routes,
  scrollBehavior(to, from, savedPosition) { // 滚动行为
    if (savedPosition) {
      return savedPosition
    } else {
      return {x: 0, y: 0}
    }
  }
})

// 路由守卫
// let whiteList = ['/login']
// router.beforeEach((to, from, next) => {
//   let token = getToken()
//   // !whiteList.includes(to.path)
//   if (!token && to.path != '/login') {
//     return next('/login')
//   } else {
//     return next()
//   }
// })

export default router


// WEBPACK FOOTER //
// ./src/router/index.js